module.exports = __webpack_public_path__ + "img/Jerusalem45.d0dd24d4.png";